import { render, staticRenderFns } from "./InfoTwo.vue?vue&type=template&id=32b6c2f3&"
import script from "./InfoTwo.vue?vue&type=script&lang=js&"
export * from "./InfoTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b6c2f3')) {
      api.createRecord('32b6c2f3', component.options)
    } else {
      api.reload('32b6c2f3', component.options)
    }
    module.hot.accept("./InfoTwo.vue?vue&type=template&id=32b6c2f3&", function () {
      api.rerender('32b6c2f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/info-tabs/InfoTwo.vue"
export default component.exports